// extracted by mini-css-extract-plugin
export default {"external":"acwILc","smeSwitcher":"bcwILc","activeLinkType":"ccwILc","linkWrapper":"dcwILc"};